<template >
  <v-app light>
    <v-content>
      <section>
        <v-parallax src="/home-image.jpg" height="600">
        <v-layout justify-center align-center>
          <v-flex xs12 sm6 md4>
            <v-card color="rgba(0,0,0,0)" flat>
              <v-img src="/CB-logo.png" max-height="200" contain></v-img>
              <v-layout column align-center justify-center class="white--text">
                <h1 class="yellow--text mb-2 mt-2 display-3 text-xs-center"></h1>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout column wrap class="my-5" align-center>
          <h1  style="font-family: 'DM Serif Display', serif; font-weight: normal; font-style: normal; font-size: 70px;">CampusBox</h1>
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center"></div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-title primary-title class="layout justify-center">
                      <div style="font-family: 'DM Serif Display', serif; font-weight: normal; font-style: normal; font-size: 32px;">Conveyance</div>
                    </v-card-title>
                    <v-card-text class = "text-xs-justify">
                      This is one of the major problems which we we, as students, face in our campus. We are trying to
                      solve this issue by creating a separate portal for students to post their travel details, and allows other students
                      to view, search and request for pooling on such posts, which can be accepted or rejected by the user.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-title primary-title class="layout justify-center">
                      <div style="font-family: 'DM Serif Display', serif; font-weight: normal; font-style: normal; font-size: 32px;">Buy And Sell</div>
                    </v-card-title>
                    <v-card-text class = "text-xs-justify">
                      We students face problems while buying and selling things as there is no exclusive portal to facilitate such transactions,
                      and using other platforms leads to various inconveniences. Thus, we aim at connecting all such buyers and sellers
                      through a common platform and making these purchases hassle-free. 
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-title primary-title class="layout justify-center">
                      <div style="font-family: 'DM Serif Display', serif; font-weight: normal; font-style: normal; font-size: 32px;">Future Prospects</div>
                    </v-card-title>
                    <v-card-text class = "text-xs-justify">
                      We at CampusBox are trying to create a platform where all the students of IIT Kanpur can interact exclusively.
                      After successfully implementing basic components, we plan on integrating this portal further, such as creating a
                      news-feed that connects all the clubs and teams with the concerned students.
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs12 sm4 class="my-3">
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div style="font-family: 'DM Serif Display', serif; font-weight: normal; font-style: normal; font-size: 32px;">Get Started</div>
                
              </v-card-title>
              <v-btn large outline color="#35455c" @click.stop="dialog = true">
                <v-icon small left>fa-user-plus</v-icon>Sign Up
              </v-btn>

              <v-btn large outline color="#35455c" @click="login">
                <v-icon small left>fas fa-sign-in-alt</v-icon>Login
              </v-btn>
            </v-card>
            <div v-if="dialog">
              <Popup :dialog="dialog" @change="change"></Popup>
            </div>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center></v-layout>
      </section>

      <section>
        <v-parallax
          src="/home-image.jpg"
          height="380"
        >
          <v-layout column align-center justify-center>
            <h1 style="font-family: 'DM Serif Display', serif; font-weight: normal; font-style: normal; font-size: 80px;">About Us</h1>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-5">
            <v-flex xs12 sm4 ma-3 v-for="person in team" :key="person.name">
              <v-card flat class="text-xs-center ma-3" color>
                <v-responsive class="pt-4">
                  <v-avatar size="120" class="blue lighten-2" contain>
                    <img :src="person.avatar" />
                  </v-avatar>
                </v-responsive>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">{{person.name}}</div>
                </v-card-title>

                <v-list class="transparent">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">work</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>{{person.role}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">email</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>{{person.email}}</v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
    </v-content>
  </v-app>
</template>

<script>
import Popup from "@/components/Popup.vue";
export default {
  name: "GetStarted",
  components: {
    Popup
  },
  data() {
    return {
      dialog: false,
      team: [
        {
          name: "Varun Gupta",
          avatar: "/varun.jpg",
          email: "varungp@iitk.ac.in",
          role: "Frontend"
        },
        {
          name: "Mohammad Talib Siddiqui",
          avatar: "talib.jpeg",
          email: "mtalib@iitk.ac.in",
          role: "Frontend"
        },
        {
          name: "Shashwat Gupta",
          avatar: "/shashwat.jpeg",
          email: "shgupta@iitk.ac.in",
          role: "Backend"
        },
        {
          name: "Manan Agarwal",
          avatar: "/manan.jpg",
          email: "agarwalm@iitk.ac.in",
          role: "Backend"
        }
      ]
    };
  },
  methods: {
    login: function() {
      this.$router.push("login");
    },
    // eslint-disable-next-line
    change: function($event) {
      this.dialog = false;
    }
  }
};
</script>
